import styled from 'styled-components';
import { Link } from 'react-scroll';
import {GoThreeBars} from 'react-icons/go'
import {BiCodeAlt} from 'react-icons/bi'


const Nav = styled.nav`
    background : rgb(255,255,255,0.88);
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content:center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top:0;
    transition: top 0.5s;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }
`
const NavbarContainer = styled.div`
    display:flex;
    justify-content:space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
`
const NavLogo = styled.div`
     font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: #000;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.7rem;
    display: flex;
    align-items: center;
    margin-left: 24px;

`
const NavIcon = styled.div`
    color: #993299;
    font-size: 2.2rem;
    position: absolute;
    transform: translate(-90%,8%);

`
const MobileIcon = styled.div`
    display:none;
    
    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%,50%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #000
    }
`
const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -402px;

    @media screen and (max-width: 990px) {
        margin-right: -22px;
    }

    @media screen and (max-width: 768px) {
        display: none;
    }
`
const NavItem = styled.li`
    height: 80px;
`
const NavLinks = styled(Link)`
    font-family: 'Epilogue', sans-serif;
    color: #000;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    &:active {
        color: red;
    }
    &:hover {
        color: #8a65f0;
        transition: 0.3s ease-in-out;
    }
`
const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    
    @media screen and (max-width: 768px) {
        display:none;
    }
`
const NavBtnLink = styled(Link)`
    font-family: 'Epilogue', sans-serif;
    border-radius : 50px;
    background: #8a65f0;
    white-space: nowrap;
    padding: 10px 22px;
    color: #fff;
    font-size: 18px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: #cebfff;
        color: #000;
    }
`
function NavBar({toggle}) {
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("navbar").style.top = "0";
        } else {
            document.getElementById("navbar").style.top = "-80px";
        }
        prevScrollpos = currentScrollPos;
        }
    return (
        <>
            <Nav id="navbar">
                <NavbarContainer>
                    <NavLogo><NavIcon><BiCodeAlt /></NavIcon>&nbsp;Misty</NavLogo>
                    <MobileIcon onClick={toggle}>
                        <GoThreeBars />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to="home" spy={true} smooth={true} duration={1000} offset={-80}>Home</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="projects" spy={true} smooth={true} duration={1000} offset={-180}>Projects</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="about" spy={true} smooth={true} duration={1000} offset={-80}>About</NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavBtn>
                        <NavBtnLink to="contact" spy={true} smooth={true} duration={1000} offset={-80}>Hire me</NavBtnLink>
                    </NavBtn>
                </NavbarContainer>
            </Nav>
        </>
    )

}

export default NavBar;